import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';
import { connect } from 'react-redux';

import ButtonViewGlossary from '../../../atoms/button-view-glossary';
import InteractiveElement from '../../../atoms/interactive-element';
import styles from './range-selector.module.scss';
import { augmentClassName } from '../../../../utils/GlobalCssProxy';
import { rangeFilterUpdate } from '../../../../stores/screener/screener-redux-store';

const className = augmentClassName(styles);

export const RangeSelector = ({ modelKey, filter, updateValue, addMargin }) => {
  return (
    <Col {...className(`'root', ${addMargin ? 'mx-6' : ''}`)}>
      <Row {...className('head-row', 'align-items-center')}>
        <h3 {...className('heading')}> {filter.heading} </h3>
        <ButtonViewGlossary glossarySection={filter.glossaryLink} isScreener solid />
      </Row>
      <BarRange modelKey={modelKey} filter={filter} updateValue={updateValue} />
    </Col>
  );
};

// filters are common between both components
const filterPropTypes = PropTypes.shape({
  heading: PropTypes.string,
  selectors: PropTypes.arrayOf(PropTypes.bool),
  srText: PropTypes.arrayOf(PropTypes.string),
  descriptors: PropTypes.arrayOf(
    PropTypes.shape({
      style: PropTypes.string,
      value: PropTypes.string
    })
  ),
  fieldKey: PropTypes.string,
  glossaryLink: PropTypes.string
});

RangeSelector.propTypes = {
  modelKey: PropTypes.string,
  filter: filterPropTypes,
  updateValue: PropTypes.func,
  addMargin: PropTypes.bool
};

RangeSelector.defaultProps = {
  addMargin: true
};

const BarRange = ({ modelKey, filter, updateValue }) => {
  return (
    <span>
      <Container fluid>
        <Row
          {...className('py-3')}
          // TIAA Analytics Tracking
          data-analytics-linkname={filter.heading.replace(/ /g, '_')}
          data-analytics-section="component"
          data-analytics-componenttype="CustomFilters"
          // END TIAA Analytics Tracking
        >
          {filter.selectors.map((el, index) => (
            <InteractiveElement
              aria-checked={el}
              aria-label={filter.srText[index]}
              as="Col"
              data-key={`${el.value || ''}-${index}`}
              key={`${el.value || ''}-${index}`}
              onClick={() => updateValue(modelKey, index)}
              role="checkbox"
              tabIndex="0"
              {...className('rating-bar', !el && 'inactive')}
            ></InteractiveElement>
          ))}
        </Row>
        <Row {...className('d-flex', 'justify-content-between', 'px-2')}>
          {filter.descriptors.map((item, index) => {
            return (
              <div data-key={`${item.value || ''}-${index}`} key={`${item.value || ''}-${index}`}>
                <Col {...className('rating-bar-label', item.style)}> {item.value} </Col>
              </div>
            );
          })}
        </Row>
      </Container>
    </span>
  );
};

BarRange.propTypes = {
  modelKey: PropTypes.string,
  filter: filterPropTypes,
  updateValue: PropTypes.func
};

const mapStateToProps = (state, ownProps) => {
  return {
    filter: state.filterReducer.filters.rangeSelectors[ownProps.modelKey]
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateValue: (modelKey, index) => dispatch(rangeFilterUpdate(modelKey, index))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RangeSelector);
